module.exports = __webpack_public_path__ + "static/img/video-bg.af1a8aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/video-bg.jpg
// module id = mBZj
// module chunks = 1